// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-form-item__control--input{display:block;width:100%;font-family:inherit}", ""]);
// Exports
module.exports = exports;
